import URL from '../api_url';

export const SESSIONS_API = `${URL}/sessions`;
